import { useMemo } from 'react';

type AlertType = 'regular' | 'amber' | 'red' | 'green' | 'Regular' | 'Amber' | 'Red' | 'Green';

type Color = 'BeakerPink' | 'FozzieOrange' | 'OscarGreen' | undefined;

const statusColorMap: { [status: string]:Color } = {
    red: 'BeakerPink',
    amber: 'FozzieOrange',
    green: 'OscarGreen',
    regular: undefined,
};

export function useAlertTypeColor(status?: AlertType): Color {
    return useMemo(() => (status ? statusColorMap[status.toLocaleLowerCase()] : undefined), [status]);
}
